export default "__VITE_ASSET__DBRU9AOo__"